import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { FuncionarioTreinamento } from "../../../../rh/domain/models/funcionario_treinamento";
import { IGetFuncionarioTreinamentosUseCase } from "../../../presentation/useCases/read/get_funcionario_treinamentos_use_case";

import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";


export class GetFuncionarioTreinamentosUseCase extends BasePaginatedUseCase<FuncionarioTreinamento> implements IGetFuncionarioTreinamentosUseCase {
  constructor(
    private readonly repository: ITerceirizacaoRepository,
  ) {
    super();
  }

  async getFuncionarioTreinamentos(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<void> {
    const response = await this.repository.getFuncionarioTreinamentos(idFuncionario, page, pageSize);

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}